<template>
  <div class="my-6">
    <med-category-btns></med-category-btns>

    <!-- <div class="d-md-none">
      <v-divider></v-divider>
      <med-browsing-options></med-browsing-options>
      <v-divider></v-divider>
    </div> -->
  </div>
</template>

<script>
// import MedBrowsingOptions from "./MedBrowsingOptions.vue";
import MedCategoryBtns from "./MedCategoryBtns";
// note this has watchers for loading, mode, and detail
// this component must have data.mode:"something"
// and must have methods for detailChange(detail)

export default {
  components: {
    MedCategoryBtns,
    // MedBrowsingOptions,
  },
  name: "MedCategoryPicker",
  mixins: [
    // WatcherMixin
  ],
  props: {},
  data: function () {
    return {};
  },
  methods: {
    //},
  },
  computed: {},
};
</script>

<style scoped></style>
